import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBox, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import React from 'react';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { navigateToPage } from 'Views/Page/Content/Templates';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { secureFilesFolderUri } from 'Consts/clientUris';
import { useHistory } from 'react-router-dom';
import { dispatchDashboardContentUpdated } from 'Hooks/useRefreshEvent';
import { dataAttrs } from 'Helpers/Testing';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';

const EstatePlanningNextStepDependingOnStatusLayout = () => {
  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();
  const history = useHistory();
  const { clearModalCollection } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();

  const nextStepActionRel = resource.withRelationship(
    fr.relationships.nextStepAction.name,
    (rel) => rel,
    () => null,
  );

  const handleSubmit = async () => {
    try {
      if (nextStepActionRel.meta('resourceType') === 'fileStoreItem') {
        history.push(secureFilesFolderUri('Estate Plans'));
        return;
      }
      if (nextStepActionRel.meta('page') === true) {
        await navigateToPage(nextStepActionRel.link('related').url(), false);
        return;
      }
      await onSubmit();
      dispatchDashboardContentUpdated();
      clearModalCollection();
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Failed to submit, please try again.');
      }
    }
  };

  const EstatePlanningNextStepDependingOnStatusImage = resource.withRelationship(
    fr.relationships.image.name,
    (rel) => (
      <ImageRel relationship={rel} width={'100%'} />
    ),
    () => null,
  );

  return (
    <FDBox alignSelf={'center'} margin={4} paddingY={1}>
      <FDStack direction={'column'} spacing={3}>
        {EstatePlanningNextStepDependingOnStatusImage}
        <MetaControlField attr={'title'} />
        <MetaControlField attr={'subtitle'} />
        <FDBox alignSelf={'center'}>
          {nextStepActionRel ? <FDPrimaryActionButton
            onClick={handleSubmit}
            loading={saving}
            label={nextStepActionRel.meta('prompt') || 'Continue'}
            size="md"
            isFullWidth={false}
            {...dataAttrs('estate-planning-next-step-action-button')}
          /> : null }
        </FDBox>
      </FDStack>
    </FDBox>
  );
};

EstatePlanningNextStepDependingOnStatusLayout.defaultProps = {
};

EstatePlanningNextStepDependingOnStatusLayout.propTypes = {
};

export default EstatePlanningNextStepDependingOnStatusLayout;
